/** Sensitive actions gated behind step-up (MFA) verification — scopes a code/token to one action. */
export enum StepUpPurpose {
  PAYOUT = 'payout'
}
